module.exports = "/_next/static/images/1-ddc326f050a4a5e6a93d90a78648a2b1.jpg";